
const navigation = {
  // Navigation
  nav: {
    dashboard: "Dashboard",
    predictions: "Daily Predictions",
    titanEngine: "Titan Engine",
    engine: "Titan Engine",
    aboutUs: "About Us",
    pricing: "Pricing",
    account: "Account",
    logout: "Logout",
    login: "Login",
    register: "Register",
    tickets: "Tickets",
    monitoring: "Monitoring",
    profile: "Profile",
    settings: "Settings",
    help: "Help",
    leaderboard: "Leaderboard"
  }
};

export default navigation;
